import React from "react";
import { useLocation } from "react-router-dom";
import { PROMO_FEATURES_ENABLED } from "../config/promoConfig";

export const Navigation = (props) => {
  const location = useLocation();
  // On any page other than the homepage, nav hash links must be absolute
  // so clicking them takes the user back to the homepage section rather
  // than scrolling within a page that has no such sections.
  const isOffHomePage = location.pathname !== "/";
  const homeBase = isOffHomePage ? "https://cyberelectrix.co.nz/" : "";
  // FAQ link: absolute when off-home, root-relative when on home
  const howToHref = isOffHomePage ? "https://cyberelectrix.co.nz/how-to" : "/how-to";

  return (
    <nav id="menu" className={`navbar navbar-default navbar-fixed-top ${PROMO_FEATURES_ENABLED ? 'with-promo-banner' : 'no-promo-banner'}`}>
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href={`${homeBase}#page-top`}>
            <img
              src="/img/Banner_16x_TR_Trim&ColorEdit.png"
              alt="CyberElectrix Logo"
              style={{height: '60px', width: 'auto'}}
            />
          </a>
        </div>

        <a href="tel:+64275733478" className="navbar-call-btn">
          <i className="fa fa-phone"></i>
          <span className="call-text">Call Now</span>
        </a>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href={`${homeBase}#about`} className="page-scroll">
                About
              </a>
            </li>
            <li>
              <a href={`${homeBase}#services`} className="page-scroll">
                Services
              </a>
            </li>
            <li>
              <a href={`${homeBase}#solutions`} className="page-scroll">
                Solutions
              </a>
            </li>
            <li>
              <a href={`${homeBase}#portfolio`} className="page-scroll">
                Portfolio
              </a>
            </li>
            <li>
              <a href={`${homeBase}#testimonials`} className="page-scroll">
                Testimonials
              </a>
            </li>
            {PROMO_FEATURES_ENABLED && (
              <li>
                <a href={`${homeBase}#promos`} className="page-scroll">
                  Promos
                </a>
              </li>
            )}
            <li>
              <a href={`${homeBase}#contact`} className="page-scroll">
                Contact
              </a>
            </li>
            <li>
              <a href={howToHref}>
                How To
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
